import React from 'react';
import { clsx } from 'clsx';

import { InputContainer, Props as BaseProps } from '../input-container';
import { Currency, currencySymbols } from '@/helpers/currency';

type HtmlInputProps = Omit<JSX.IntrinsicElements['input'], 'ref'>;
type Props = HtmlInputProps &
  BaseProps & {
    currency: Currency;
    register: (any: any) => any;
  };

const CurrencyInput: React.FC<Props> = ({ id, label, currency, value, error, register, valueAsNumber, ...props }) => (
  <InputContainer id={id} label={label} error={error}>
    <div className="mt-1 flex relative rounded-md shadow-sm">
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
        <span className="text-gray-500 sm:text-sm sm:leading-5">{currencySymbols[currency]}</span>
      </div>
      <input
        {...props}
        id={id}
        name={props.name || id}
        className={clsx('form-input block w-full pl-7 pr-12 sm:text-sm sm:leading-5', {
          'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:ring-red': error,
        })}
        placeholder={props.placeholder || '0.00'}
        aria-describedby={`${id}-currency`}
        ref={register({
          required: props.required,
          valueAsNumber: Boolean(valueAsNumber),
          validate: (value: string) => !value.includes(',') || 'Usa punto para decimales.',
        })}
        aria-required={props.required}
      />
      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <span className="text-gray-500 sm:text-sm sm:leading-5" id={`${id}-currency`}>
          {currency}
        </span>
      </div>
    </div>
  </InputContainer>
);

export default CurrencyInput;
